/* @flow */
import moment from 'moment';
import type { TFunction } from 'react-i18next';

import navigation from 'services/NavigationService';
import { apiService } from 'services/ServiceRegistry';
import { activities } from 'components/Activity/ActivityData.js';
import { translate as translateStatus } from 'utils/statuses';
import type { BlockedEmailDomain } from 'models/BlockedEmailDomains';

import Form from '../_.extend';

export type Variant = 'new' | 'edit';

export const makeFields = (domainData: BlockedEmailDomain | {}, t: TFunction) => {
  return [
    {
      name: 'domainDetails',
      label: t('general:email_domains.labels.details'),
      fields: [
        {
          name: 'domainName',
          label: t('general:email_domains.labels.domain_name'),
          rules: 'required|string',
          value: typeof domainData.domain === 'string' ? domainData.domain : null,
        },
        {
          name: 'isDisabled',
          label: t('general:email_domains.labels.is_disabled'),
          rules: 'required|boolean',
          value: typeof domainData.is_disabled === 'boolean' ? domainData.is_disabled : false,
        },
      ],
    },
  ];
};

export class EmailDomainsForm extends Form {}

export const emailDomainFormFactory = (
  fields: Array<*>,
  localState: Object,
  t: TFunction,
  variant: Variant = 'new',
  id?: string
) => {
  const hooks = {
    async onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const jsonObj = {
        domain: form.$('domainDetails.domainName').value,
        is_disabled: form.$('domainDetails.isDisabled').value,
      };

      try {
        let response: Object;

        switch (variant) {
          case 'new':
            response = await apiService.createResource('blocked-email-domains', jsonObj);
            break;

          case 'edit':
            if (!id) {
              throw new Error('Domain entity not defined!');
            }
            response = await apiService.putResource(`blocked-email-domains/${id}`, jsonObj);
            break;
        }

        localState.isLoading = false;
        localState.responseMessage = t('general:messages.save_success');

        setTimeout(() => {
          localState.showResponseMessage = false;
          /*eslint-disable max-nested-callbacks*/
          setTimeout(() => {
            // Snackbar animation 225ms
            navigation.goBack();
          }, 225);
        }, 1200);

        return response;
      } catch (error) {
        localState.isLoading = false;
        localState.responseMessage = t('general:messages.save_error');
        localState.hasSuccess = false;
        localState.hasError = true;
      }
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  let name = '';
  switch (variant) {
    case 'new':
      name = t('general:actions.create_new_email_domain');
      break;

    case 'edit':
      name = t('general:actions.edit_email_domain');
      break;
  }

  return new EmailDomainsForm({ fields }, { hooks, name });
};
